import { Brand, createBranded } from '@deltasierra/type-utilities';

export type CrmRecipientListSourceId = Brand<number, 'CrmRecipientListSourceId'>;
export const CrmRecipientListSourceId = createBranded<CrmRecipientListSourceId>();
